"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M34.5834 23.9583H16.4584C16.044 23.9583 15.6466 24.123 15.3536 24.416C15.0605 24.709 14.8959 25.1064 14.8959 25.5208C14.8959 25.9352 15.0605 26.3327 15.3536 26.6257C15.6466 26.9187 16.044 27.0833 16.4584 27.0833H34.5834C34.9978 27.0833 35.3953 26.9187 35.6883 26.6257C35.9813 26.3327 36.1459 25.9352 36.1459 25.5208C36.1459 25.1064 35.9813 24.709 35.6883 24.416C35.3953 24.123 34.9978 23.9583 34.5834 23.9583Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.5209 4.16666C21.2975 4.16666 17.1689 5.41906 13.6572 7.76549C10.1455 10.1119 7.40849 13.447 5.79225 17.3489C4.176 21.2509 3.75312 25.5445 4.57707 29.6868C5.40103 33.8291 7.43481 37.6341 10.4212 40.6205C13.4077 43.6069 17.2126 45.6407 21.3549 46.4647C25.4972 47.2886 29.7908 46.8658 33.6928 45.2495C37.5948 43.6333 40.9298 40.8962 43.2763 37.3846C45.6227 33.8729 46.8751 29.7443 46.8751 25.5208C46.8696 19.859 44.618 14.4307 40.6145 10.4272C36.611 6.42376 31.1827 4.17218 25.5209 4.16666ZM25.5209 43.75C21.9155 43.75 18.3911 42.6809 15.3933 40.6778C12.3956 38.6748 10.0591 35.8278 8.67937 32.4968C7.29965 29.1659 6.93865 25.5006 7.64203 21.9645C8.3454 18.4284 10.0816 15.1803 12.631 12.6309C15.1804 10.0815 18.4285 8.34531 21.9646 7.64193C25.5007 6.93856 29.166 7.29955 32.4969 8.67928C35.8279 10.059 38.6749 12.3955 40.6779 15.3932C42.681 18.391 43.7501 21.9154 43.7501 25.5208C43.7446 30.3538 41.8222 34.9873 38.4048 38.4047C34.9874 41.8221 30.3539 43.7445 25.5209 43.75Z",
    fill: fill
  }));
};

exports["default"] = _default;